import React, { useState } from "react";
import Footer from "./footer"
const CostEstimator = () => {
  const [activeTab, setActiveTab] = useState("basic");

  return (
    <div className="font-[Poppins] bg-white">

      {/* HERO */}
      <div
        className="h-[140px] md:h-[180px] bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c')",
        }}
      ></div>

      {/* MAIN SECTION */}
      <section className="bg-[#dcd3e9] py-10 px-5">
        <div className="max-w-[1000px] mx-auto">

          {/* TITLE */}
          <h2 className="text-2xl md:text-3xl mb-2">Cost Estimator</h2>

          <p className="text-sm text-gray-600 mb-5">
            Wondering how much it'll cost to build your home? Just fill out the
            form and get an estimate. Our expert can help fine-tune the details.
          </p>

          {/* TABS */}
          <div className="flex gap-3 mb-5 flex-wrap">
            <button
              onClick={() => setActiveTab("basic")}
              className={`px-4 py-2 rounded-md text-sm ${
                activeTab === "basic"
                  ? "bg-[#caa9f2] text-white"
                  : "bg-[#e7dff4]"
              }`}
            >
              Basic Details
            </button>

            <button
              onClick={() => setActiveTab("all")}
              className={`px-4 py-2 rounded-md text-sm ${
                activeTab === "all"
                  ? "bg-[#caa9f2] text-white"
                  : "bg-[#e7dff4]"
              }`}
            >
              All Details
            </button>
          </div>

          {/* CARD */}
          <div className="bg-[#f5f5f5] p-5 md:p-8 rounded-xl">

            {/* FORM GRID */}
            <form
              className={`grid gap-4 ${
                activeTab === "basic"
                  ? "grid-cols-1 md:grid-cols-4"
                  : "grid-cols-1 md:grid-cols-4"
              }`}
            >
              {/* BASIC FORM */}
              {activeTab === "basic" && (
                <>
                  <input placeholder="Full Name" className="input" />
                  <input placeholder="Enter your mobile number" className="input" />
                  <input placeholder="Email" className="input" />

                  {/* FIELD GROUP */}
                  <div className="relative flex flex-col">
                    <label className="absolute -top-2 left-3 bg-[#f5f5f5] px-1 text-xs text-gray-500">
                      I want to start construction in
                    </label>
                    <select className="input">
                      <option>0-3 months</option>
                      <option>3-6 months</option>
                      <option>6-12 months</option>
                    </select>
                  </div>

                  <div className="relative flex flex-col">
                    <label className="absolute -top-2 left-3 bg-[#f5f5f5] px-1 text-xs text-gray-500">
                      City Name
                    </label>
                    <select className="input">
                      <option>Bhubaneswar</option>
                      <option>Cuttack</option>
                    </select>
                  </div>

                  <input placeholder="Plot Area (in Sqft)" className="input" />
                  <input placeholder="Plot Area (in Sqft)" className="input" />

                  <div className="relative flex flex-col">
                    <label className="absolute -top-2 left-3 bg-[#f5f5f5] px-1 text-xs text-gray-500">
                      Build Ground Floor
                    </label>
                    <select className="input">
                      <option>G(Ground Floor)</option>
                    </select>
                  </div>

                  {/* HELP TEXT */}
                  <p className="text-xs text-gray-500 md:col-span-4">
                    The total area of land that you own, including the footprint
                    of any structures built on it.
                  </p>

                  {/* RADIO */}
                  <div className="md:col-span-4 flex flex-col md:flex-row gap-4 items-start md:items-center text-sm">
                    <p>Do you own a plot or land?</p>

                    <label className="flex items-center gap-2">
                      <input type="radio" name="land" />
                      Yes
                    </label>

                    <label className="flex items-center gap-2">
                      <input type="radio" name="land" />
                      No
                    </label>
                  </div>

                  {/* CHECKBOX */}
                  <div className="md:col-span-4 flex items-start gap-2 text-xs">
                    <input type="checkbox" className="mt-1" />
                    <p>
                      I agree to{" "}
                      <span className="text-purple-600 font-medium">
                        Privacy Policy
                      </span>{" "}
                      and{" "}
                      <span className="text-purple-600 font-medium">
                        Terms & Conditions
                      </span>
                    </p>
                  </div>

                  <button className="md:col-span-4 w-full md:w-[180px] mx-auto py-2 rounded-md bg-gradient-to-r from-purple-300 to-purple-500 text-white">
                    Calculate
                  </button>
                </>
              )}

              {/* ALL DETAILS FORM */}
              {activeTab === "all" && (
                <>
                  <input placeholder="Full Name" className="input" />
                  <input placeholder="Enter your mobile number" className="input" />
                  <input placeholder="Email" className="input" />

                  <div className="relative flex flex-col">
                    <label className="absolute -top-2 left-3 bg-[#f5f5f5] px-1 text-xs text-gray-500">
                      I want to start construction in
                    </label>
                    <select className="input">
                      <option>0-3 months</option>
                      <option>3-6 months</option>
                      <option>6-12 months</option>
                    </select>
                  </div>

                  <div className="relative flex flex-col">
                    <label className="absolute -top-2 left-3 bg-[#f5f5f5] px-1 text-xs text-gray-500">
                      Build Ground Floor
                    </label>
                    <select className="input">
                      <option>G(Ground Floor)</option>
                    </select>
                  </div>

                  <input placeholder="Total Builtup (in Sqft)" className="input" />
                  <input placeholder="Parking Area (in Sqft)" className="input" />

                  <select className="input">
                    <option>Utilities Area (in Sqft)</option>
                    <option>Basic</option>
                    <option>Luxury</option>
                  </select>

                  <div className="relative flex flex-col">
                    <label className="absolute -top-2 left-3 bg-[#f5f5f5] px-1 text-xs text-gray-500">
                      City Name
                    </label>
                    <select className="input">
                      <option>Bhubaneswar</option>
                      <option>Cuttack</option>
                    </select>
                  </div>

                  {/* RADIO */}
                  <div className="md:col-span-4 flex flex-col md:flex-row gap-4 text-sm">
                    <p>Do you own a plot or land?</p>

                    <label className="flex items-center gap-2">
                      <input type="radio" name="land2" />
                      Yes
                    </label>

                    <label className="flex items-center gap-2">
                      <input type="radio" name="land2" />
                      No
                    </label>
                  </div>

                  {/* CHECKBOX */}
                  <div className="md:col-span-4 flex items-start gap-2 text-xs">
                    <input type="checkbox" className="mt-1" />
                    <p>
                      I agree to{" "}
                      <span className="text-purple-600 font-medium">
                        Privacy Policy
                      </span>{" "}
                      and{" "}
                      <span className="text-purple-600 font-medium">
                        Terms & Conditions
                      </span>
                    </p>
                  </div>

                  <button className="md:col-span-4 w-full md:w-[180px] mx-auto py-2 rounded-md bg-gradient-to-r from-purple-300 to-purple-500 text-white">
                    Calculate
                  </button>
                </>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* INPUT STYLE */}
      <style>{`
        .input {
          width: 100%;
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #ccc;
          font-size: 13px;
          background: white;
        }
      `}</style>
      <Footer/>
    </div>
  );
};

export default CostEstimator;